export abstract class BaseResponse<T> {
  public success: boolean;
  public body: T;

  constructor(success: boolean, body: T) {
    this.success = success;
    this.body = body;
  }
}
